import 'core-js';

import Vue from 'vue';
import Vue2TouchEvents from 'vue2-touch-events';
import VueScript2 from 'scripts/lib/script2';
import VueLazyLoad from 'vue-lazyload';
import VueMq from 'vue-mq';

import { loading } from 'scripts/config/images.js';
import components from './components/index.js';
import store from './store/index.js';
import { ucfirst, upcase, unhandleize } from './filters/string.js';
import { money, moneyWithoutDecimals } from './filters/money.js';
import { getSizedImageUrl } from './filters/images.js';
import render from './helpers/module.js';

__webpack_public_path__ = window.__webpack_public_path__; // eslint-disable-line no-underscore-dangle, camelcase

const cssVars = require('../styles/variables.scss');

Vue.config.productionTip = false;

Vue.use(Vue2TouchEvents);
Vue.use(VueScript2);

Vue.use(VueLazyLoad, {
  loading,
  preload: 1.3,
  attempt: 1,
});

// temporarily hardcoding breakpoints until empty cssVars object is debugged.
Vue.use(VueMq, {
  breakpoints: {
    mobile: 641,
    tablet: 1000,
    desktop: 1280,
    hd: Infinity,
  },
});

Vue.filter('ucfirst', ucfirst);
Vue.filter('upcase', upcase);
Vue.filter('unhandleize', unhandleize);
Vue.filter('money', money);
Vue.filter('moneyWithoutDecimals', moneyWithoutDecimals);
Vue.filter('imageUrl', getSizedImageUrl);

function renderComponents(){
  const vueRoots = document.querySelectorAll('[data-vue-root]');
  vueRoots.forEach((root) => {
    render({
      root,
      component: new Vue({ store }),
      is: components[root.dataset.vueRoot],
    });
  });
}

window.addEventListener('DOMContentLoaded', () => {
  renderComponents();
});
